import { Box, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import Lottie from "lottie-react";
import PaymentSuccess from "../../assets/payment-success.json";
import PaymentCancel from "../../assets/payment-cancel.json";

const PREFIX = "PaymentStatus";

const classes = {
  paymentStatusTitle: `${PREFIX}-paymentStatusTitle`,
  successIcon: `${PREFIX}-successIcon`,
  cancelIcon: `${PREFIX}-cancelIcon`,
};

const PaymentStatusContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  [`& .${classes.paymentStatusTitle}`]: {
    marginBottom: "20px",
  },

  [`& .${classes.successIcon}`]: {
    width: "300px",
    height: "300px",
  },

  [`& .${classes.cancelIcon}`]: {
    width: "300px",
    height: "300px",
  },
}));

const PaymentStatus = ({ success, cancel }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  useEffect(() => {
    let redirectionTimeOut = setTimeout(() => {
      window.location.href = `/dashboard`;
    }, 3000);

    return () => {
      clearTimeout(redirectionTimeOut);
    };
  });

  return (
    <PaymentStatusContainer>
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        {success && (
          <>
            <Typography variant="h2" className={classes.paymentStatusTitle}>
              {t("purchaseGeoloc.paymentSuccess")}
            </Typography>
            <Lottie
              animationData={PaymentSuccess}
              loop
              autoplay
              className={classes.successIcon}
            />
          </>
        )}
        {cancel && (
          <>
            <Typography variant="h2">
              {t("purchaseGeoloc.paymentCancel")}
            </Typography>
            <Lottie
              animationData={PaymentCancel}
              loop
              autoplay
              className={classes.cancelIcon}
            />
          </>
        )}
        <Typography variant="h3">{t("purchaseGeoloc.redirecting")}</Typography>
      </Box>
    </PaymentStatusContainer>
  );
};

export default PaymentStatus;
